import { ConfirmationDialog } from "components";
import { CommercialUserProps } from "../../state/actionType";
import { CommercialUserStatus } from "props/enum";
import { useState } from "react";
import { ErrorIcon } from "assets";
import { connect } from "react-redux";
import { updateCommercialUserStatus } from "../../state/action";

interface OwnProps {
  onClose: () => void;
  commercialUserData: CommercialUserProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateCommercialUserStatus: React.FC<Props> = ({
  onClose,
  commercialUserData,
  onUpdateUserStatus
}) => {
 const [error, setError] = useState("");

  const handleConfirm = async () => {
    const newStatus =
      commercialUserData.status === CommercialUserStatus.Active
        ? CommercialUserStatus.Deleted
        : CommercialUserStatus.Active;

    try {
      await onUpdateUserStatus(commercialUserData.id.toString(), newStatus);
      onClose();
    } catch (err: any) {
      setError("Failed to update user status. Please try again.");
      console.error("Status update error:", err);
    }
  };
  return (
    <>
      <ConfirmationDialog
        isErrorIcon
        title={`Confirm your update`}
        subTitle={`${ commercialUserData?.email  }`}
        message={`Are you sure you want to ${
          commercialUserData.status === CommercialUserStatus.Active
            ? CommercialUserStatus.Deleted
            : CommercialUserStatus.Active
        } this user?`}
        onCancel={onClose}
        error={error}
        onConfirm={handleConfirm}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateUserStatus: (
    userID: string,
    status:string
  ) =>
    dispatch(updateCommercialUserStatus(userID,status)),
});

export default connect(null, mapDispatchToProps)(HandleUpdateCommercialUserStatus);
